// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "8c96131eb018b87907663f11d9fa159f2e64528c/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","41":"a0ec33ed","777":"dfb468f1","788":"c61fe626","804":"51a6e114","810":"5b7541cc"}[chunkId] + ".chunk.js";
};